import { mutationFor, queryFor } from "@visioni/a3s-client-api/app";
import { listSnapshotsEndpoint } from "../client-messages/snapshots";
import { listSnapshotHistoryEndpoint } from "../client-messages/snapshot-history";
import { listClipsEndpoint, countClipsByHourEndpoint, countClipsInRangeEndpoint } from "../client-messages/clips";
import { listLivestreamsEndpoint } from "../client-messages/livestreams";
import { getTimelapseVideoEndpoint, requestTimelapseVideoEndpoint } from "../client-messages/timelapse";
import {
  cancelCompilationEndpoint,
  getCompilationEndpoint,
  listCompilationsEndpoint,
  requestCompilationEndpoint,
} from "../client-messages/compilation";

export const snapshotsQuery = queryFor(listSnapshotsEndpoint);

export const snapshotHistoryQuery = queryFor(listSnapshotHistoryEndpoint);

export const clipsQuery = queryFor(listClipsEndpoint);

export const clipHourlyCountsQuery = queryFor(countClipsByHourEndpoint);

export const clipRangeCountQuery = queryFor(countClipsInRangeEndpoint);

export const livestreamsQuery = queryFor(listLivestreamsEndpoint);

export const timelapseVideoStatusQuery = queryFor(getTimelapseVideoEndpoint);

export const requestTimelapseVideoMutation = mutationFor(requestTimelapseVideoEndpoint);

/**
 * Declared for consistency with every other GET endpoint in this file, but
 * `useCompilationsList` doesn't consume it — its `useInfiniteQuery` needs a
 * fresh `queryFn` per cursor page, which this factory's fixed-queryParams
 * shape doesn't support. Same split as `a3s-activity`'s `listActivityQuery`
 * vs `useActivityList`.
 */
export const compilationsQuery = queryFor(listCompilationsEndpoint);

export const requestCompilationMutation = mutationFor(requestCompilationEndpoint);

/**
 * Single compilation by id. Camera-scoped, so it needs the site and camera
 * alongside the request id — see `useCompilation`, which uses it to resolve a
 * deep-linked compilation the current list page doesn't contain.
 */
export const compilationQuery = queryFor(getCompilationEndpoint);

export const cancelCompilationMutation = mutationFor(cancelCompilationEndpoint);
